import React, { useEffect } from 'react'
import styles from './index.module.css'
import { Select } from '../../../components/ModalInputs'
import { useDispatch, useSelector } from 'react-redux';
import { getYears, getKurses } from '../../../actions/exam_board'
import Button from '../../../components/Button';
import { getTeachersList } from '../../../actions/common';
import { getPublications } from '../../../actions/publication';

const defaultStreams = [{ name: 'Основной', value: 0 }, { name: 'Донабор', value: 1 }];

const Index = ({ filters, setFilters, getExamBoardList }) => {

    const { years, kurses } = useSelector(state => state.exam_board);
    const { teachers } = useSelector(state => state.common);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getYears());
        dispatch(getTeachersList());
    }, [])

    useEffect(() => { //выбрать актуальный год в years select
        if (years) {
            const actual = years.find(el => el.actual === true);
            setFilters({ ...filters, year: actual?.xp_key })
        }
    }, [years])



    const handleChange = (name, value) => { // Обработчик изменения параметров поиска
        setFilters({
            ...filters,
            [name]: value
        });
    }

    const handleGetData = () => {
        dispatch(getPublications(filters));
    }

    return (
        <div>
            <div className={styles.container}>
                <div className={styles.inputsRow}>
                    <div className={styles.container_select}>
                        <Select
                            name='year'
                            label='Учебный год'
                            value={filters.year}
                            onChange={(e) => handleChange(e.target.name, Number(e.target.value))}>
                            <option value='0'>Все</option>
                            {years
                                .map(el => <option key={el.xp_key} value={el.xp_key}>{el.name}</option>)}
                        </Select>
                    </div>

                    <div className={styles.container_select}>
                        <Select
                            name='mid'
                            label='Преподаватель'
                            value={filters.mid ?? 0}
                            onChange={(e) => handleChange(e.target.name, Number(e.target.value))}>
                            <option value='0'>Все</option>
                            {teachers?.map(el =>
                                <option key={el.mid} value={el.mid}>{el.calc_fio}</option>)
                            }

                        </Select>

                    </div>

                    <Button className={styles.button} onClick={() => handleGetData()}>Обновить</Button>
                </div>
            </div>
        </div>
    )
}

export default Index